const { createAction } = require('@reduxjs/toolkit');

export const toggleSidebar = createAction('[Layout] Toggle sidebar');

export default toggleSidebar;
